import { Breakpoints, styled } from "@vw-marketing/us-components";

import { VWTheme } from "../../../../shared/typings/vw-theme";

interface StyledHeaderWrapper {
  theme: VWTheme;
  hasImage: boolean;
}

interface StyledHeaderWrapper {
  theme: VWTheme;
  hasImage: boolean;
}

export const StyledVehicleCardWrapper: any = styled.div`
  ${({ hasImage }: StyledHeaderWrapper) => {
    return `
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      min-width: 232px;
      width: 100%;
      
      @media (min-width: ${Breakpoints.b560}px) {
        align-items: flex-start;
        flex-direction: ${!hasImage ? 'column' : 'row'};
        min-width: 366px;

        ${hasImage && `
          > * {
            flex-shrink: 0;
          }
        `}
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        min-width: 404px;
      }
    `;
  }}
`;

export const StyledHeaderWrapper: any = styled.div`
  ${({ theme, hasImage }: StyledHeaderWrapper) => {
    return `
      align-items: center;
      align-self: stretch;
      background: ${theme.colors.background.tertiary};
      border-left: 0.5px solid ${theme.colors.border.default};
      border-radius: 12px 12px 0 0;
      border-right: 0.5px solid ${theme.colors.border.default};
      border-top: 0.5px solid ${theme.colors.border.default};
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static350};
      justify-content: center;
      padding: ${theme.size.static250} ${theme.size.static350};
      
      @media (min-width: ${Breakpoints.b560}px) {
      ${hasImage && `
        align-items: flex-start;
        align-self: stretch;
        border-bottom: 0.5px solid ${theme.colors.border.default};
        border-radius: 12px 0 0 12px;
        border-right: 0px;
        flex: 1;
        justify-content: flex-start;
        max-width: 50%;
        min-height: 220px;
        padding: ${theme.size.static300} ${theme.size.static350};
      `}
      }
    `;
  }}
`;

export const StyledImageContainer: any = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 137px;
  
  img {
    width: 90% !important;
    max-width: 180px !important;
    height: auto !important;
    transform: scale(1.6);
  }

  @media (min-width: ${Breakpoints.b560}px) {
    height: auto;
    justify-content: center;
    
    img {
      width: 100% !important;
      max-width: 125px !important;
      transform: scale(1.5);
    }
  }
`;

interface StyledImageWrapperProps {
  theme: VWTheme;
  imgUrl: string;
  noContent: boolean;
}

export const StyledVehicleInformationContainer: any = styled.div`
  ${({ theme }: StyledImageWrapperProps) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static100};
      width: 100%;
    `;
  }}
`;

interface StyledInfoWrapperProps {
  theme: VWTheme;
  hasImage: boolean;
}

export const StyledVehicleDataWrapper: any = styled.div`
  ${({ theme, hasImage }: StyledInfoWrapperProps) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      background: ${theme.colors.background.primary};
      border-bottom: 0.5px solid ${theme.colors.border.default};
      border-left: 0.5px solid ${theme.colors.border.default};
      border-radius: 0 0 12px 12px;
      border-right: 0.5px solid ${theme.colors.border.default};
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static200};
      padding: ${theme.size.static250} ${theme.size.static350};

      @media (min-width: ${Breakpoints.b560}px) {
        ${hasImage && `
          align-items: flex-start;
          border-radius: 0 12px 12px 0;
          border-left: 0px;
          border-top: 0.5px solid ${theme.colors.border.default};
          flex: 1 0 0;
          gap: ${theme.size.static300};
          justify-content: start;
          padding: ${theme.size.static300} ${theme.size.static350} ${theme.size.static300} ${theme.size.static400};
        `}
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        gap: ${theme.size.static350};
      }
    `;
  }}
`;

export const StyledSubscriptionsContainer: any = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.b560}px) {
    gap: ${({ theme }: { theme: VWTheme }) => theme.size.static100};
  }
`;

export const StyledAdditionalUsersContainer: any = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.b560}px) {
    gap: ${({ theme }: { theme: VWTheme }) => theme.size.static100};
  }
`;


